module.exports = __webpack_public_path__ + "static/media/MuseoSansBlack.1808b5f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBlack/MuseoSansBlack.ttf
// module id = 635
// module chunks = 0